/**
 * Created by meirr on 9/8/16.
 */
define(function (require) {

    var lpUtils = require('utils/lpUtils');
    var BaseFilterItem = require('web-agent-components/BaseFilterItemViewController');

    var FilterItemTextInput = BaseFilterItem.extend({

        LPElementsMap: {
            textInput: "input"
        },
        LPTemplatesFiles: {
            textInputItem: 'LP_filter_full_table_text_input.html'
        },

        initialize: function (constructorData) {
            var textInputTemplate = require('web-agent-templates/' + this.LPTemplatesFiles.textInputItem);
            // var textInputTemplate = lpUtils.loadResource(this.LPTemplatesFiles.textInputItem);
            var placeholder = constructorData.item_placeholder ? constructorData.item_placeholder : '';

            this.view  = this.createView({
                template: textInputTemplate,
                doNotAddChild: true,
                elementType: "div",
                textInjection: {
                    item_placeholder: placeholder
                }
            });
        },
        events: function () {
        },
        render: function () {

        }
    });

    FilterItemTextInput.prototype.getValue = function() {
        var inputElement = this.getFirstElement(this.LPElementsMap.textInput, this.view);
        return (inputElement && inputElement.value) ? inputElement.value : undefined;   //empty string should return as undefined
    };

    FilterItemTextInput.prototype.updateFilterUI = function (filterUIData) {
        this.getFirstElement(this.LPElementsMap.textInput, this.view).value = filterUIData || "";
    };


    return FilterItemTextInput;

});
